import { createStore } from "solid-js/store";
import { createSimpleContext } from "./helper";
export const {
  use: useRoute,
  provider: RouteProvider
} = createSimpleContext({
  name: "Route",
  init: () => {
    const [store, setStore] = createStore(process.env["OPENCODE_ROUTE"] ? JSON.parse(process.env["OPENCODE_ROUTE"]) : {
      type: "home"
    });
    return {
      get data() {
        return store;
      },
      navigate(route) {
        console.log("navigate", route);
        setStore(route);
      }
    };
  }
});
export function useRouteData(type) {
  const route = useRoute();
  return route.data;
}